module.exports = __webpack_public_path__ + "img/avatar1.4a820814.png";